import { lightTheme } from '@sketch/global-styles';

const PillOwnerVariant = {
    kind: 'special',
    textTint: lightTheme.colors.foreground.secondary.D,
    background: lightTheme.colors.brand.teal.default.E,
};
const PillAdminVariant = {
    kind: 'special',
    textTint: lightTheme.colors.foreground.secondary.D,
    background: lightTheme.colors.brand.purple.default.E,
};
const PillFinanceVariant = {
    kind: 'special',
    textTint: lightTheme.colors.foreground.secondary.D,
    background: lightTheme.colors.brand.green.default.E,
};
const PillPartyVariant = {
    kind: 'special',
    textTint: '#002F7D',
    background: `linear-gradient(
    90deg,
    rgba(232, 184, 252, 1) 0%,
    rgba(231, 219, 143, 1) 34%,
    rgba(166, 241, 232, 1) 67%,
    rgba(136, 252, 207, 1) 100%
  )`,
};

export { PillAdminVariant, PillFinanceVariant, PillOwnerVariant, PillPartyVariant };
